module.exports = __webpack_public_path__ + "img/capLock.ee2b921e.png";